import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const ContentLayout = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp32};
  align-items: stretch;
`

export const LeftColumn = styled.div`
  flex: 4;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  min-width: 0;
`

export { GroupContainer } from '@/configuration/pages/ConfigurationPage/sharedStyles'

export const CopySection = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.background.primary};

  &:first-of-type {
    border-radius: ${props => props.theme.primitives.radius.radius3} ${props => props.theme.primitives.radius.radius3}
      ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius0};
    padding-top: ${props => props.theme.spacing.sp8};
  }

  &:last-of-type {
    border-radius: ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius0}
      ${props => props.theme.primitives.radius.radius3} ${props => props.theme.primitives.radius.radius3};
    padding-bottom: ${props => props.theme.spacing.sp8};
  }

  &:first-of-type:last-of-type {
    border-radius: ${props => props.theme.primitives.radius.radius3};
  }
`

export const RightColumn = styled.div`
  flex: 4;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border-radius: ${props => props.theme.primitives.radius.radius6};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.disabled.surface};
`
